document.addEventListener("DOMContentLoaded", () => {
  const addOneTimeBtn = document.getElementById("add-bundle-onetime");
  const addSubBtn = document.getElementById("add-bundle-subscription");

  if (!addOneTimeBtn || !addSubBtn) return;

  // Global run counter to ignore stale checks
  let runCounter = 0;
  let debounceTimer = null;
  const DEBOUNCE_MS = 80;

  // Utility: are all .bundle-product inside `container` filled with non-empty data-id?
  function areAllSlotsFilled(container) {
    if (!container) return false;
    const slots = container.querySelectorAll(".bundle-product");
    if (slots.length === 0) return false;
    return Array.from(slots).every((slot) => {
      // use getAttribute to be strict about attribute presence
      const idAttr = slot.getAttribute("data-id");
      return idAttr !== null && String(idAttr).trim() !== "";
    });
  }

  // The authoritative check — reads current states and updates buttons
  function runCheckIfLatest(myRunId) {
    // if a newer run was scheduled, cancel this one
    if (myRunId !== runCounter) return;

    // Identify active purchase type
    const oneTimeActive =
      document.querySelector('[data-type="one-time"].active') !== null;
    const subActive =
      document.querySelector('[data-type="subscription"].active') !== null;

    // Default: disable both
    let enableOneTime = false;
    let enableSub = false;

    // ONE-TIME: check .one-time-bundle .bundle-product
    if (oneTimeActive) {
      const oneTimeContainer = document.querySelector(".one-time-bundle");
      enableOneTime = areAllSlotsFilled(oneTimeContainer);
    }

    // SUBSCRIPTION: find which set button is active (set-1 / set-2 / set-3)
    if (subActive) {
      const activeSetButton = document.querySelector(
        ".bundle-option.active[data-target]"
      );
      // fallback: check any element with [data-target].active
      const fallbackSetButton = document.querySelector("[data-target].active");
      const setBtn = activeSetButton || fallbackSetButton;
      if (setBtn && setBtn.dataset && setBtn.dataset.target) {
        const setName = setBtn.dataset.target.trim(); // "set-1", etc.
        const setContainer = document.querySelector(
          `[data-bundle-set="${setName}"]`
        );
        enableSub = areAllSlotsFilled(setContainer);
      } else {
        enableSub = false; // no set selected
      }
    }

    // Apply results to buttons (only if this is still the latest run)
    if (myRunId === runCounter) {
      addOneTimeBtn.disabled = !enableOneTime;
      addSubBtn.disabled = !enableSub;
    }
  }

  // Public scheduling wrapper (debounced + run-id)
  function scheduleCheck() {
    // bump the global run counter — any previous scheduled run will abort
    const myRunId = ++runCounter;

    // clear previous debounce
    if (debounceTimer) clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      runCheckIfLatest(myRunId);
    }, DEBOUNCE_MS);
  }

  // UI event triggers:
  // - clicking purchase type buttons or bundle-option (set-1/2/3)
  document.addEventListener("click", (e) => {
    // When purchase type or set buttons are clicked, scheduling is enough.
    if (
      e.target.closest('[data-type="one-time"]') ||
      e.target.closest('[data-type="subscription"]') ||
      e.target.closest("[data-target]")
    ) {
      // Immediately set buttons disabled while state resolves to avoid flicker
      addOneTimeBtn.disabled = true;
      addSubBtn.disabled = true;
      scheduleCheck();
    }

    // If user triggers a product selection that sets data-id via direct click on some product,
    // ensure we schedule check too (this covers many selection flows).
    if (
      e.target.closest(".bundle-product") ||
      e.target.closest("[data-popup-trigger]")
    ) {
      scheduleCheck();
    }
  });

  // MutationObserver: watch for attribute changes and subtree changes inside the wrapper
  const wrapper = document.querySelector(".bundle-wrapper") || document.body;
  const observer = new MutationObserver((mutations) => {
    // If any relevant mutation occurs, schedule a check.
    // We do not inspect each mutation in detail to keep it simple and robust.
    scheduleCheck();
  });

  observer.observe(wrapper, {
    attributes: true,
    subtree: true,
    attributeFilter: ["class", "data-id", "data-target"], // important attributes
    childList: true,
  });

  // Also run initial check on load
  // Also make sure initial disabled state is consistent
  addOneTimeBtn.disabled = true;
  addSubBtn.disabled = true;
  scheduleCheck();

  // Optional: expose a function in case other scripts want to trigger a re-check
  window.bundleButtons_checkSlots = scheduleCheck;
});
